export default "__VITE_ASSET__0b2540af__"